import React, { useState } from 'react';
import Navbar from '../common/Navbar';
import TicketList from '../tickets/TicketList';
import './Dashboard.css';

/**
 * Admin Dashboard - Shows all tickets with status management
 */
const AdminDashboard = () => {
  // State to trigger ticket list refresh
  //remove setRefreshTrigger as it is not used in the AdminDashboard component  when redeploying to netlify
  const [refreshTrigger] = useState(0);

  return (
    <div className="dashboard">
      <Navbar />
      
      <div className="dashboard-content">
        <div className="container">
          <div className="dashboard-header">
            <div>
              <h1 className="dashboard-title">Admin Dashboard</h1>
              <p className="dashboard-subtitle">
                Manage and track all IT service requests
              </p>
            </div>
            <div className="dashboard-stats">
              <div className="stat-card">
                <span className="stat-label">Total Tickets</span>
                <span className="stat-value">All</span>
              </div>
            </div>
          </div>

          <div className="dashboard-grid admin-grid">
            {/* Full width ticket list for admin */}
            <div className="dashboard-column full-width">
              <TicketList 
                isAdmin={true} 
                refreshTrigger={refreshTrigger}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;